'use strict';

var base = require('org/product/base');
var detail = require('base/product/detail');
var isOsx = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
const { isMobile } = require('../../../../../../app_lyonscg/cartridge/client/default/js/util/utils');

$('.j-collapse').readmore({
    moreLink: '<span class="view-more-container"><span class="view-more-dots">...</span><a class="view-more-link a-link" href="#">View More</></span>',
    lessLink: '<a class="view-less-link a-link" href="#">View Less</>',
    embedCSS: false
    // beforeToggle: function (trigger, element, expanded) {
    //     expanded ? element.find('.dots').addClass('hidden') : element.find('.dots').removeClass('hidden');
    //     console.log('before', trigger, element, expanded);
    // }
});

base.initMobileCarousel();

$(function () {
    if (isOsx === false) {
        $('.apple-pay-pdp').css('display', 'none');
    }
    if (isMobile() === false) {
        $('#sidebar').stickySidebar({
            topSpacing: 120,
            bottomSpacing: 120,
            containerSelector: '#sidebarContainer',
            innerWrapperSelector: '.sidebar__inner'
        });
    }
});

/**
 * Checks if the email value entered is correct format
 * @param {string} email - email string to check if valid
 * @returns {boolean} Whether email is valid
 */
function validateEmail(email) {
    var regex = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
    var test = regex.test(email);
    return test;
}

/**
 * Validate required fields are filled in
 * @returns {boolean} true/false
 */
function checkRequiredFields() {
    var formFields = $('.data-column select:required, .data-column input:required');
    var requiredfields = formFields.length;
    var valid = false;
    var count = 0;
    formFields.each(function () {
        if ($(this).val().length !== 0 && $(this).val() !== ' ') {
            if ($(this).attr('type') === 'email') {
                if (validateEmail($(this).val())) {
                    $(this).removeClass('is-invalid');
                    $(this).siblings('.invalid-feedback').html('');
                    count++;
                } else {
                    $(this).addClass('is-invalid');
                    $(this).siblings('.invalid-feedback').html('Please fill valid email');
                }
            } else {
                count++;
            }
        }
    });

    if (count === requiredfields) {
        valid = true;
    }
    return valid;
}

/**
 * Validate required custom options selected, if not add-to-cart button disabled
 */
function validateCustomOptions() {
    var str = $('#text-to-display').val();
    var valid = checkRequiredFields();
    var individualOption = $('.attribute .individual-option-attribute');
    var individualColorOption = $('.attribute .color-attribute .color-value');
    var customSelectDefaultOption = $('.attribute .custom-select .default-option');
    var customSelectDefaultOptionSelected = $('.attribute .custom-select .default-option:selected').length;
    if ($('#text-to-display')) {
        if ($('.customization').hasClass('embroidered')) {
            if (str.length > 0 && str !== ' ' && $('.text-style-anchor.embroidered').hasClass('selected') && $('.lace-color').hasClass('selected') && $('.text-color').hasClass('selected')) {
                $('.add-to-cart, .apple-pay-pdp').removeAttr('disabled');
                $('.js-google-pay-container').removeClass('d-none');
                $('.add-to-wishlist-action').removeClass('disabled');
                if ($('.attributes .selected.unselectable').length > 0) {
                    $('.add-to-cart, .apple-pay-pdp').prop('disabled', 'true');
                    $('.js-google-pay-container').addClass('d-none');
                    $('.add-to-wishlist-action').addClass('disabled');
                }
            } else {
                valid = false;
                $('.add-to-cart, .apple-pay-pdp').prop('disabled', 'true');
                $('.js-google-pay-container').addClass('d-none');
                $('.add-to-wishlist-action').addClass('disabled');
            }
        }
        if ($('.customization').hasClass('engraved')) {
            if (str.length > 0 && str !== ' ' && $('.text-style-anchor.engraving').hasClass('selected')) {
                $('.add-to-cart, .apple-pay-pdp').removeAttr('disabled');
                $('.js-google-pay-container').removeClass('d-none');
                $('.add-to-wishlist-action').removeClass('disabled');
                if ($('.attributes .selected.unselectable').length > 0) {
                    $('.add-to-cart, .apple-pay-pdp').prop('disabled', 'true');
                    $('.js-google-pay-container').addClass('d-none');
                    $('.add-to-wishlist-action').addClass('disabled');
                }
            } else {
                valid = false;
                $('.add-to-cart, .apple-pay-pdp').prop('disabled', 'true');
                $('.js-google-pay-container').addClass('d-none');
                $('.add-to-wishlist-action').addClass('disabled');
            }
        }
    }

    if (valid) {
        $('.add-to-cart, .apple-pay-pdp').removeAttr('disabled');
        $('.js-google-pay-container').removeClass('d-none');
        $('.add-to-wishlist-action').removeClass('disabled');
        if ($('.attributes .selected.unselectable').length > 0) {
            $('.add-to-cart, .apple-pay-pdp').prop('disabled', 'true');
            $('.js-google-pay-container').addClass('d-none');
            $('.add-to-wishlist-action').addClass('disabled');
        }
    } else {
        $('.add-to-cart, .apple-pay-pdp').prop('disabled', 'true');
        $('.js-google-pay-container').addClass('d-none');
        $('.add-to-wishlist-action').addClass('disabled');
    }

    if (individualOption.length > 0 && !individualOption.hasClass('selected')) {
        $('.add-to-cart, .apple-pay-pdp').prop('disabled', 'true');
        $('.js-google-pay-container').addClass('d-none');
        $('.add-to-wishlist-action').addClass('disabled');
    }
    if (individualColorOption.length > 0 && !individualColorOption.hasClass('selected')) {
        $('.add-to-cart, .apple-pay-pdp').prop('disabled', 'true');
        $('.js-google-pay-container').addClass('d-none');
        $('.add-to-wishlist-action').addClass('disabled');
    }
    if (customSelectDefaultOption.length > 0 && customSelectDefaultOptionSelected) {
        $('.add-to-cart, .apple-pay-pdp').prop('disabled', 'true');
        $('.js-google-pay-container').addClass('d-none');
        $('.add-to-wishlist-action').addClass('disabled');
    }
}

/**
 * Textbox should only accept alphanumeric and approved special characters
 */
function checkTextCharacters() {
    $('body').on('keyup', '#text-to-display, #text-to-display-line-2, #text-to-display-line-3, #text-to-display-line-4', function () {
        var str = $(this).val();
        str = str.replace(/[^a-zA-Z0-9 #$\.@':"\-\/!áéíóúÁÉÍÓÚÑñ]+/g, '').replace(/\s\s+/g, '');
        $(this).val(str);
        validateCustomOptions();
    });
    $('body').on('keyup change input', '#gc-recipient-name, #gc-recipient-email, #gc-from-name, #gc-text-message', function (e) {
        e.preventDefault();
        validateCustomOptions();

        if ($(this).hasClass('gc-text-message')) {
            $(this).siblings('.remaining-feedback').html('Remaining characters : ' + (250 - $(this).val().length));
        }
    });
    $('body').on('blur', '.giftcard-fields .required input', function (e) {
        e.preventDefault();
        if ($(this).val().length !== 0 && $(this).val() !== ' ') {
            if ($(this).attr('type') !== 'email') {
                $(this).removeClass('is-invalid');
                $(this).siblings('.invalid-feedback').html('');
            }
        } else {
            $(this).addClass('is-invalid');
            $(this).siblings('.invalid-feedback').html('Please fill out this field.');
        }
    });
}

/**
* Update Add To Cart buttom text after variation changes
* @param {Object} product - product data
*/
function updateAddToCartText(product) {
    var $addToCartBtn = $('.add-to-cart-container .add-to-cart');
    var $addToWishlistBtn = $('.add-to-wishlist-action');
    var message = $addToCartBtn.data('instock-message');
    var $addToCartTextElement = $addToCartBtn.find('.js-add-to-text');
    var $addToCartIcon = $addToCartBtn.find('.fa-shopping-cart');
    if (!product.available) {
        message = $addToCartBtn.data('outofstock-message');
        $addToCartTextElement.text(message);
        $addToCartIcon.addClass('d-none');
        $addToWishlistBtn.addClass('disabled');
    } else {
        $addToCartTextElement.text(message);
        $addToCartIcon.removeClass('d-none');
        $addToWishlistBtn.removeClass('disabled');
    }
}

/**
* Update Add To Cart buttom text after variation changes
* @param {Object} product - product data
* @param {Object} $productContainer - product container
*/
function updateWishlistIconDisplay(product, $productContainer) {
    var $wishlistContainer = $productContainer.find('.js-add-to-wishlist-action');
    var url = $wishlistContainer.data('href');
    if (url) {
        $.ajax({
            url: (url + '?pid=' + product.id),
            type: 'get',
            success: function (response) {
                $wishlistContainer.html(response);
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

// Product Images Grid Expande and Collapse
let expBtn = document.querySelector('#grid-expander');
let expGrid = document.querySelector('#top-grid');
let expTop = document.querySelector('.grid-close-anchor');

expBtn.addEventListener('click', function () {
    expGrid.classList.toggle('grid-expanded');
    expBtn.classList.toggle('activated');
    if (expBtn.classList.contains('activated')) {
        expBtn.setAttribute('aria-expanded', true);
        expBtn.innerText = 'Show Less';
    } else {
        expBtn.setAttribute('aria-expanded', false);
        expBtn.innerText = 'Show More';
        expTop.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
});
// Create mutation observer that watches for primary images to change and if they have update the expander button
const targetNode = document.getElementById('top-grid');
const config = { attributes: true, childList: true, subtree: true };

const callback = (mutationList, observer) => { // eslint-disable-line no-unused-vars
    for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
            // When switching to option with less than 5 images hide the expander
            if ($('#top-grid .grid-image').length > 5) {
                $('#grid-expander').removeClass('expHide');
            } else {
                $('#grid-expander').addClass('expHide');
            }
        }
    }
};
const gridObserver = new MutationObserver(callback);

// Start observing the target node for configured mutations
gridObserver.observe(targetNode, config);

// If the PDP images are clicked, show the carousel.
$('body').on('click', '.image-grid-image', function (e) {
    e.preventDefault();
    var currentImageNumber = $(this).data('current-item');
    base.carouselInit(currentImageNumber);
});

$('.close-primary-images-carousel').on('click', function () {
    $('.primary-images-desktop-zoom .primary-images-carousel').hide();
    $('.product-carousel').slick('unslick');
    $('html').removeClass('overflow');
});

$('body').on('click', '#engraving-samples-btn', function (e) {
    e.preventDefault();
    var caro = $('.engraved-images-carousel .slick-component .slick-inner');
    if (caro.hasClass('slick-initialized')) {
        caro.slick('resize');
    } else {
        $('.engraved-images-carousel .slick-component .slick-inner').slick({
            appendDots: caro.parent('.slick-component').find('.slick-nav'),
            prevArrow: caro.parent('.slick-component').find('.prevArrow'),
            nextArrow: caro.parent('.slick-component').find('.nextArrow'),
            infinite: false
        });
    }
    $('.engraved-images-carousel').toggle();
    $('html').addClass('overflow');
});
$('.close-engraved-sample-carousel').on('click', function () {
    $('.engraved-images-carousel').hide();
    $('.engraved-images-carousel .slick-component .slick-inner').slick('unslick');
    $('html').removeClass('overflow');
});

$(document).on('click', '.individual-option-attribute', function () {
    if (!$(this).hasClass('selected')) {
        $(this).siblings('.individual-option-attribute').removeClass('selected');
        $(this).addClass('selected');
        var selectedDataIndex = $(this).attr('data-index');
        var selectItem = $(this).parents('.attribute').find('.individual-option-select option[data-index="' + selectedDataIndex + '"]').val();
        $(this).parents('.attribute').find('.individual-option-select').val(selectItem)
        .trigger('change');

        $('body').on('product:afterAttributeSelect', function () {
            $('.prices-add-to-cart-actions').removeClass('d-none');
            validateCustomOptions();
        });
    }
});

// Watch for a default attribute button to be selected then update the hidden select element with its matching value.
$(document).on('click', '.custom-select-attribute', function () {
    var clickedButton = $(this);
    var selectedDataIndex = clickedButton.attr('data-index');
    if (!clickedButton.hasClass('selected')) {
        clickedButton.siblings('.custom-select-attribute').removeClass('selected');
        clickedButton.parents('.attribute').find('.custom-select option[selected="selected"]').prop('selected', false);
        clickedButton.addClass('selected');
        clickedButton.parents('.attribute').find('.custom-select option[data-index="' + selectedDataIndex + '"]').prop('selected', true);
        clickedButton.parents('.attribute').find('.custom-select').trigger('change');

        $('body').on('product:afterAttributeSelect', function () {
            $('.prices-add-to-cart-actions').removeClass('d-none');
            validateCustomOptions();
        });
    } else {
        var reset = clickedButton.parents('.attribute').find('.custom-select option[class="default-option"]').val();
        clickedButton.parents('.attribute').find('.custom-select option[data-index="' + selectedDataIndex + '"]').prop('selected', false);
        clickedButton.parents('.attribute').find('.custom-select option[class="default-option"]').prop('selected', true);
        clickedButton.removeClass('selected');
        clickedButton.parents('.attribute').find('.custom-select').val(reset).trigger('change');
    }
});

// Custom attribute selection
checkTextCharacters();

$('.data-column').on('click', '.text-style-anchor', function () {
    var $this = $(this);
    var value = $this.data('customvalue');
    $this.siblings('.selected').removeClass('selected');
    $this.addClass('selected');
    if ($this.hasClass('engraving')) {
        $('input[name="engraving-text-style"]').val(value);
    } else if ($this.hasClass('embroidered')) {
        $('input[name="embroidered-text-style"]').val(value);
    }
    $('#text-to-display').trigger('keyup');
});
$('.data-column').on('click', '.text-color-anchor', function () {
    var $this = $(this);
    var value = $this.data('customvalue');
    $this.siblings('.selected').removeClass('selected');
    $this.addClass('selected');
    $this.parent('.text-colors').siblings('.form-control-label').children('.selectedColor').html(value);
    if ($this.hasClass('text-color')) {
        $('input[name="embroidered-text-color"]').val(value);
    } else if ($this.hasClass('lace-color')) {
        $('input[name="lace-color"]').val(value);
    }
    $('#text-to-display').trigger('keyup');
});
$('.data-column').on('change', 'select.flags', function () {
    $('input[name="flag"]').val($(this).find('option:selected').data('value-id'));
});
$('.data-column').on('change', 'select.options-select', function () {
    if ($(this).find('option:selected').data('value-id') === 'none') {
        $('body').on('product:afterAttributeSelect', function () {
            $('.add-to-cart, .apple-pay-pdp').removeAttr('disabled');
            $('.js-google-pay-container').removeClass('d-none');
            $('.add-to-wishlist-action').removeClass('disabled');
            if ($('.attributes .selected.unselectable').length === 1) {
                $('.add-to-cart, .apple-pay-pdp').prop('disabled', 'true');
                $('.js-google-pay-container').addClass('d-none');
                $('.add-to-wishlist-action').addClass('disabled');
            }
            validateCustomOptions();
        });
    } else {
        $('body').on('product:afterAttributeSelect', function () {
            $('.add-to-cart, .apple-pay-pdp').prop('disabled', 'true');
            $('.js-google-pay-container').addClass('d-none');
            $('.add-to-wishlist-action').addClass('disabled');
            if ($('.attributes .selected.unselectable').length === 0 && $('.attributes .attribute button').length > 0) {
                $('.add-to-cart, .apple-pay-pdp').removeAttr('disabled');
                $('.js-google-pay-container').removeClass('d-none');
                $('.add-to-wishlist-action').removeClass('disabled');
            }
            validateCustomOptions();
        });
    }
    checkTextCharacters();
});

var exportDetail = $.extend({}, detail, {
    addToCart: base.addToCart,
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
                response.container.find('.product-name').text(response.data.product.productName);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
                response.container.find('.product-name').text(response.data.product.productName);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
                $('.product-name').text(response.data.product.productName);
            }

            updateAddToCartText(response.data.product);
            updateWishlistIconDisplay(response.data.product, response.container);
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            if (response.product.readyToOrder || response.product.available) {
                $('.js-google-pay-container').removeClass('d-none');
            } else {
                $('.js-google-pay-container').addClass('d-none');
            }

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);

            // Update Wishlist pid Add/remove
            if (response.product.readyToOrder) {
                var wishlistButton = $('.wishlistTile');
                var GuestWishlistButton = $('.wishlistGuest');
                if (wishlistButton.length !== 0) {
                    wishlistButton.attr('pid', response.product.id);
                }
                if (GuestWishlistButton.length !== 0) {
                    GuestWishlistButton.attr('pid', response.product.id);
                }
            }
        });
    }
});

module.exports = exportDetail;
